import React from 'react';

import styles from 'styles/components/gigs/GigDetails.module.scss';

const padding = {
  padding: '20px 15px',
  backgroundColor: '#fff',
  borderTop: '1px solid #e0e0e0',
};

const AdditionalDetails = ({ gig }) => {
  if (!gig.location && !gig.physical_product) return null;

  return (
    <>
      {gig.location && (
        <div style={padding}>
          <h3 className={styles.heading}>Location-based</h3>

          <p>Requires travel to {gig.location}</p>
        </div>
      )}

      {gig.physical_product && (
        <div style={padding}>
          <h3 className={styles.heading}>Physical product included</h3>

          <p>A product will be sent to you for demonstration purposes</p>
        </div>
      )}
    </>
  );
};

export default AdditionalDetails;
